import React from 'react';
import styled from '@emotion/styled';
import { colorPalette } from '@sharefiledev/antd-config';
export interface MandatoryFieldIndicatorProps {
	displayOutside: boolean;
	scale: number;
}

export const MandatoryFieldIndicator = ({
	displayOutside,
	scale,
}: MandatoryFieldIndicatorProps) => {
	return (
		<Wrapper {...{ scale }}>
			<StyledAsteriskIcon {...{ displayOutside }} data-testid="asterisk-icon">
				&#42;
			</StyledAsteriskIcon>
		</Wrapper>
	);
};

const Wrapper = styled.span<{ scale: number }>`
	transform: ${({ scale }) => `scale(${scale})`};
	position: absolute;
	right: 0;
	top: 0;
`;

const StyledAsteriskIcon = styled.span<{ displayOutside: boolean }>(
	({ displayOutside }) => ({
		position: 'absolute',
		color: colorPalette.red6,
		fontSize: '18px',
		marginTop: '0px',
		top: displayOutside ? '2px' : '0px',
		right: displayOutside ? '-9px' : '4px',
	})
);
